import appMenu    from 'app/router/menu';
import coreuiMenu from '@/router/menu';

export default ({ t, userInfo }) => ({
  items: [
    ...appMenu({ t, userInfo }),
    ...coreuiMenu({ t, userInfo })
  ]
});
